<template>
  <div :class="$style['landing-mask']">
    <div :class="$style['landing-mask-l-t']" />
    <div :class="$style['landing-mask-r-b']" />
    <div :class="$style['landing-mask-l-b']">
      <scroll-indicator :class="$style['scroll-indicator']" />
    </div>
    <div :class="$style['landing-mask-b']">
      <scroll-indicator :class="$style['scroll-indicator']" />
    </div>
  </div>
</template>

<script>
import ScrollIndicator from '../ScrollIndicator'

export default {
  name: 'LandingMask',
  components: {
    ScrollIndicator,
  },
}
</script>

<style lang="less" module>
.landing-mask {
  .size(100%);

  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;

  &-l-t {
    .size(4.97rem,5.35rem);

    position: absolute;
    top: 0;
    left: 0;
    background: url('./images/mask-l-t.png') no-repeat;
    background-size: 100% 100%;
  }

  &-r-b {
    .size(5.54rem,2.75rem);

    display: none;
    position: absolute;
    bottom: 0;
    right: 0;
    background: url('./images/mask-r-b.png') no-repeat;
    background-size: 100% 100%;
  }

  &-l-b {
    .size(7.52rem,5.03rem);

    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    background: url('./images/mask-l-b.png') no-repeat;
    background-size: 100% 100%;
  }

  &-b {
    .size(10.8rem, 4.47rem);

    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    background: url('./images/mask-b.png') no-repeat;
    background-size: 100% 100%;
  }
}

:global(.fp-completely) {
  .scroll-indicator {
    animation: fadeIn 1s ease forwards;
    animation-delay: 1s;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// 横屏
:global(.landing-screen-landscape) {
  .landing-mask {
    &-l-b,
    &-r-b {
      display: block;
    }

    &-l-b {
      .scroll-indicator {
        left: 0.9rem;
        bottom: 0.37rem;
        opacity: 0;
      }
    }
  }
}

// 竖屏
:global(.landing-screen-portrait) {
  .landing-mask {
    &-b {
      display: block;

      .scroll-indicator {
        left: 0;
        right: 0;
        bottom: 0.3rem;
        margin: 0 auto;
        opacity: 0;
      }
    }
  }
}
</style>
